import { render } from "./RekapPresensi.vue?vue&type=template&id=2b69522d"
import script from "./RekapPresensi.vue?vue&type=script&lang=js"
export * from "./RekapPresensi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__